import { jsx as _jsx } from "react/jsx-runtime";
import { MealTemplateView } from ".";
import { MealOptionViewMacro } from "../../MealOption/View/Macro";
import { maybeMacrosToMacros } from "@notemeal/shared-utils-macro-protocol";
import { MacrosSummaryLabel } from "../../Macros/SummaryLabel";
export const MealTemplateViewMacro = ({ mealTemplate, containerWidth, displayMealOptions, displayMealMacros, displayMealOptionMacros, }) => {
    const mealOptions = displayMealOptions ? mealTemplate.mealOptions : [];
    const macros = maybeMacrosToMacros(mealTemplate);
    return (_jsx(MealTemplateView, { label: displayMealMacros && _jsx(MacrosSummaryLabel, { variant: "sm", macros: macros }), meal: mealTemplate.meal, containerWidth: containerWidth, mealOptions: mealOptions, renderMealOption: mealOption => _jsx(MealOptionViewMacro, { mealOption: mealOption, displayMacros: displayMealOptionMacros }) }));
};
//# sourceMappingURL=Macro.js.map